import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import TitleFragment from "./TitleFragment";
import SEO from "./SEO";
// import CareersListingData from "./data/CareersListingData";
// import arrowRight from "./images/careers/arrow-right.webp";
import whatsapp from "./images/careers/whatsapp.webp";

import '../App.css';
import './styles/Careers.css';
// import ScrollToTop from "./ScrollToTop";
import { ExpandableCard, JobBoard } from "./ExpandableCard";


function Careers() {
    const { t } = useTranslation();
    const [currentDate, setCurrentDate] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setCurrentDate(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const formattedDate = new Intl.DateTimeFormat('en-US', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' }).format(currentDate);
    const formattedTime = currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true, second: '2-digit' });


    return (
        <div className="career">
            <SEO
                title="Careers - Qt Developer Jobs"
                description="Join PthinkS, India's leading Qt and QML development company. We're hiring Qt/QML developers, C++ engineers, and software architects in Bengaluru. Apply now!"
                keywords="Qt developer jobs India, QML developer careers, C++ jobs Bengaluru, Qt software engineer jobs, PthinkS careers, embedded systems jobs India, cross-platform developer jobs, Qt QML hiring"
                url="/careers"
            />
            <TitleFragment title={t('careers.titleFragment')} />

            <div className="career_system">
                <span className="career_system_time">{formattedTime}</span>
                <br></br>
                <span>{formattedDate}</span>
            </div>

            <div >

                <div className="career_menu" >
                    {/* {CareersListingData.map((job) => (
                     <Link onClick={ScrollToTop} key={job.id} className="career_menu_card" target="_blank" to="https://chat.whatsapp.com/I8NnmXCpoDk6xtnZCA6hnQ">
                    
                        <div className="career_menu_card_div">
                            <div className="career_menu_card_div_title">{job.title}</div>
                            <div className="career_menu_card_div_exp"><b>Exp :</b> {job.experience}</div>
                            <div className="career_menu_card_div_location">({job.location})</div>
                            <div className="career_menu_card_div_location">Available Position :</div>
                        </div>
                        <div className="career_menu_card_div_second">
                            <img className="career_menu_card_arrow" src={arrowRight} alt="Arrow right" />
                            <span className="career_menu_card_div_span">{job.availablePositions}</span>
                        </div>
                    </Link>
                ))} */}
                    <JobBoard />
                </div>

                <div className="career_subscribe_main">
                    <div className="career_paragraph">{t('careers.paragraph')}</div>

                    <div className="career_subscribe_div">
                        <a
                            className="career_subscribe"
                            target="_blank"
                            href="https://chat.whatsapp.com/I8NnmXCpoDk6xtnZCA6hnQ"
                        >
                            <div className="career_subscribe_title">{t('careers.subscribeFor')} <span style={{ color: "#2962FF" }}>{t('careers.job')}</span> <span style={{ color: "#FF8A65" }}>{t('careers.alerts')}</span>!!!
                                <img className="career_subscribe_img" src={whatsapp} />
                            </div>
                        </a>
                    </div>
                </div>

            </div>

            {/* <div className="app_sub_title">Usefull Thoughts :</div> */}
        </div >
    )
}



export default Careers;